/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
export var GenerationHistoryAssetType;
(function (GenerationHistoryAssetType) {
    GenerationHistoryAssetType["IMAGE"] = "image";
    GenerationHistoryAssetType["VIDEO"] = "video";
})(GenerationHistoryAssetType || (GenerationHistoryAssetType = {}));
export var GenerationHistoryAssetOrderBy;
(function (GenerationHistoryAssetOrderBy) {
    GenerationHistoryAssetOrderBy["CREATE_DATE"] = "created_date";
})(GenerationHistoryAssetOrderBy || (GenerationHistoryAssetOrderBy = {}));
export var GenerationHistoryAssetState;
(function (GenerationHistoryAssetState) {
    GenerationHistoryAssetState["QUEUED"] = "queued";
    GenerationHistoryAssetState["IN_PROGRESS"] = "inProgress";
    GenerationHistoryAssetState["SUCCESS"] = "success";
    GenerationHistoryAssetState["FAILED"] = "failed";
    GenerationHistoryAssetState["CANCELLED"] = "cancelled";
})(GenerationHistoryAssetState || (GenerationHistoryAssetState = {}));
